import { SettingsService } from './../../_services/settings.service';
import { CandidateActionService } from './../../_services/candidate-action.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Component, OnInit, ViewChild, TemplateRef, Input, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'src/app/_services/local-storage.service';
import { CandidateService } from 'src/app/_services/candidate.service';
import { GlobalService } from 'src/app/_services/global.service';
declare const clevertap;

@Component({
  selector: 'app-call-log',
  templateUrl: './call-log.component.html',
  styleUrls: ['./call-log.component.scss']
})
export class CallLogComponent implements OnInit {

  candidate: any;
  callnote: any;
  selectedOutcome: any = null;
  outcomeid: any;
  outcomeError: Boolean = false;
  outcomeslist: any;
  callLogList: any;
  outcomename: any;
  isEdit: boolean = false;
  selectedOutcomeText: any;
  newoutcometext: any;
  talentvalue: string = null;
  pipeline_list = GlobalService.PipelineStatus;

  backupObj: { callnote: any; selectedOutcome: any; };

  @Input() calllogforCandidate: any;
  @Input() BulkcalllogforCandidate: any[];
  @Input() editCallLogData;
  @Output() passEntry: EventEmitter<any> = new EventEmitter();

  @ViewChild("errorModal") errorModal: TemplateRef<any>;
  @ViewChild("successModal") successModal: TemplateRef<any>;
  talentErrorMessage: string;



  constructor(public modalService: NgbModal, public candidateaction: CandidateActionService,
    public settingservice: SettingsService, private _localstorageservice: LocalStorageService, public _candidateservice: CandidateService) { }

  ngOnInit() {
    this.candidate = this.calllogforCandidate  //Single candidate Details
    this.getOutcomesList(this._localstorageservice.getItem('usernumber'))

    if (this.candidate) {
      let data = {
        candidatenumber: this.candidate.candidatenumber,
        start: 3
      }
      this.candidateaction.getCandidateCallLog(data).subscribe((res: any) => {
        if (res.status == 'success') {
          this.callLogList = res.message.calllogs
        }
      })
    }

    if (this.editCallLogData && this.editCallLogData.editFlag) {
      this.isEdit = this.editCallLogData.editFlag

      if (this.isEdit) {
        this.candidateaction.getSingleCallLogDetails(this.editCallLogData.calllogid).subscribe((res: any) => {
          this.selectedOutcome = res.message[0].outcomeid
          this.selectedOutcomeText = res.message[0].outcometext
          this.callnote = res.message[0].callnote
          this.backupObj = {
            callnote: this.callnote,
            selectedOutcome: this.selectedOutcomeText
          }
        })
      }
    }

  }

  getOutcomesList(outcomename) {
    this.settingservice.getOutcomeList(outcomename).subscribe((res: any) => {
      if (res.message) {
        this.outcomeslist = (res.message).filter((x) => { return (x.isactive == 1 && x.outcometype != null) });
      }
    });
  }

  outcomeselected(outcomeid) {
    this.outcomeid = outcomeid;
    let newoutcomedetails = this.outcomeslist.filter(x => {
      return x.outcomeid == this.outcomeid
    })
    this.newoutcometext = newoutcomedetails[0].outcometext
    this.outcomeError = false;
  }

  closeModal() {
    this.modalService.dismissAll();
  }

  createCallLog() {
    if (this.outcomeid) {
      this.callnote = this.callnote.replace( /(<([^>]+)>)/ig, '');
      let callLogobj = {}
      //for single candidate 
      if (this.candidate) {
        callLogobj = {
          callLogInsert: [{
            calllog: {
              candidatenumber: this.candidate.candidatenumber,
              createdby:this._localstorageservice.getItem('userid'),
              outcomeid: this.outcomeid,
              callnote: this.callnote != undefined ? "'" + this.callnote.replace( /(<([^>]+)>)/ig, '').replace(/'/g, "''") + "'" : null
            },
            activitylog: {
              userid:this._localstorageservice.getItem('userid'),
              action: "'create'",
              tablename: "'calllog'",
              usertype: "'user'",
              updatedfieldname: "'all'",
              type: "'calllog'",
              createdby:this._localstorageservice.getItem('userid'),
              newvalue: { Outcome: this.newoutcometext, Note: this.callnote != undefined ? this.callnote.replace( /(<([^>]+)>)/ig, '').replace(/'/g, "''") : null },
            }
          }]
        }
      } else {
        //for bulk candidate
        let callLogInsertObj = [];
        for (let iterator of this.BulkcalllogforCandidate) {
          callLogInsertObj.push({
            calllog: {
              candidatenumber: iterator,
              createdby:this._localstorageservice.getItem('userid'),
              outcomeid: this.outcomeid,
              callnote: this.callnote != undefined ? "'" + this.callnote.replace( /(<([^>]+)>)/ig, '').replace(/'/g, "''") + "'" : null
            },
            activitylog: {
              userid:this._localstorageservice.getItem('userid'),
              action: "'create'",
              tablename: "'calllog'",
              usertype: "'user'",
              updatedfieldname: "'all'",
              type: "'calllog'",
              createdby:this._localstorageservice.getItem('userid'),
              newvalue: { Outcome: this.newoutcometext, Note: this.callnote != undefined ? this.callnote.replace( /(<([^>]+)>)/ig, '').replace(/'/g, "''") : null },
            }
          })
        }
        callLogobj = {
          callLogInsert: callLogInsertObj
        }
      }


      this.candidateaction.AddCandidateCallLog(callLogobj).subscribe((res: any) => {
        if (res.status == 'success') {
          this.modalService.dismissAll()
          if (this.candidate) {
            this.modalService.dismissAll()
            const dialogRef = this.modalService.open(this.successModal, { size: 'md' as 'lg', centered: true, backdrop: 'static', keyboard: false });
            //- Clevertap Call log event
            let ctObj = {
              "Name": this.calllogforCandidate.firstname + " " + this.calllogforCandidate.lastname,
              "Job title": this.calllogforCandidate.jobtitle,
              "Company Name": this.calllogforCandidate.companyname,
              "Source": this.calllogforCandidate.source,
              "Location": this.calllogforCandidate.locationname
            }
            this.cleverTapEvent("Call log", ctObj);
          } else {
            this.modalService.dismissAll()
            this.passEntry.emit('calllogAdded')
            //- Clevertap Add bulk Call log event
            let ctObj = {
              "No. of candidates": this.BulkcalllogforCandidate.length,
              "Note": this.callnote.replace( /(<([^>]+)>)/ig, '').replace(/'/g, "''"),
            }
            this.cleverTapEvent("Bulk Call log", ctObj);
          }
        } else {
          this.modalService.dismissAll()
          this.passEntry.emit('error')
        }
      })
    }
    else {
      this.outcomeError = true
    }
  }


  editCallLog() {
    let newobj = {
      callnote: this.callnote.replace( /(<([^>]+)>)/ig, ''),
      selectedOutcome: this.newoutcometext ? this.newoutcometext : this.selectedOutcomeText
    }

    let activity = [];
    activity = [{
      action: "'update'",
      tablename: "'calllog'",
      createdby:this._localstorageservice.getItem('userid'),
      userid: this._localstorageservice.getItem('userid'),
      usertype: "'user'",
      type: "'calllog'",
      updatedfieldname: "'all'",
      oldvalue: { Outcome: this.backupObj.selectedOutcome, Note: this.backupObj.callnote },
      newvalue: { Outcome: newobj.selectedOutcome, Note: newobj.callnote.replace( /(<([^>]+)>)/ig, '').replace(/'/g, "''") }
    }]

    let Obj = {
      "candidatenumber": this.editCallLogData.candidatenumber,
      "log": {
        "calllogid": this.editCallLogData.calllogid,
        "callnote": this.callnote ? `'${this.callnote.replace( /(<([^>]+)>)/ig, '')}'` : null,
        "outcomeid": this.outcomeid ? this.outcomeid : null
      },
      "activity": activity
    }

    this.candidateaction.EditCandidateCallLog(Obj).subscribe((res: any) => {
      if (res.status == 'success') {
        this.modalService.dismissAll();
        this.passEntry.emit('updated')

      } else {
        this.modalService.dismissAll();
        this.passEntry.emit('error')

      }
    })
  }


  SaveTalent() {
    if (this.talentvalue != null) {

      let data = {
        "candidatenumber": this.candidate.candidatenumber,
        "usernumber": this._localstorageservice.getItem('usernumber'),
        "pipelinestatus": this.talentvalue,
        "activitylog": [
          {
            "action": "'update'",
            "tablename": "'candidate'",
            "type": "'pipeline status'",
            "updatedfieldname": "'pipelinestatus'",
            "oldvalue": "'" + this.candidate.pipelinestatus + "'",
            "newvalue": "'" + this.talentvalue + "'"
          }
        ]
      }
      this._candidateservice.updatepipelineStatus(data).subscribe((res: any) => {
        if (res.status == "success") {
          this.modalService.dismissAll();
          this._candidateservice.createCandidateData();
          this.passEntry.emit('calllogAdded')
        }
        else {
          this.modalService.dismissAll();
          this.passEntry.emit('error')

        }
      })
    }
    else {
      this.talentErrorMessage = 'Please Select Talent Status'
    }
  }

  cleverTapEvent(eventName, data) {
    clevertap.event.push(eventName, data);
    console.log(eventName + " CT event");
  }
}
